// src/services/autoScoringService.js
import { getFunctions, httpsCallable } from 'firebase/functions';

/**
 * Call the Firebase Cloud Function to auto-score answers
 * This replaces the direct OpenAI API call for security
 * 
 * @param {Array} submittedAnswers - Array of submitted answer strings
 * @param {Array} questions - Array of question objects with answer and pointValue
 * @returns {Promise<Object>} Scoring results with scores, autoScored, totalScore
 */
export const autoScoreAnswers = async (submittedAnswers, questions) => {
  try {
    const functions = getFunctions();
    const autoScoreFunction = httpsCallable(functions, 'autoScoreAnswers');
    
    console.log('🔍 Calling Cloud Function for auto-scoring...');
    console.log('Submitted Answers:', submittedAnswers);
    console.log('Questions:', questions.map(q => ({ answer: q.answer, points: q.pointValue })));
    
    const result = await autoScoreFunction({
      submittedAnswers,
      questions
    });
    
    console.log('✅ Auto-scoring results from Cloud Function:', result.data);
    
    return result.data;
  } catch (error) {
    console.error('❌ Error calling auto-scoring Cloud Function:', error);
    console.error('Error details:', error.message, error.code);
    throw error;
  }
};

export const AUTO_SCORING_ROUNDS = [
  'Take Two', 
  'Take Three', 
  'Here\'s a Letter', 
  'Take Four', 
  'Take Five', 
  'Dodge the Top'
];

